import config from "../../config";
import { addConfigurableProductToCart } from "../Common/Providers/ConfigurableProductApi";

window.kidsArt = {};
window.kidsArt.getPageCounts = async () => {
    const response = await $.get(`${config.localeApi}/configurable_products/kids-art-keepsakes`);
    window.kidsArt.response = response.data;
    return response.data.steps.find((step) => step.code === 'page_count').options.map((option) => {
        return option.code
    });
};
window.kidsArt.addToCart = async (pageCount, returnArtwork, coverDesign, title) => {
    if (typeof returnArtwork !== 'boolean') {
        throw new TypeError('value of returnArtwork should be boolean');
    }
    let matchingVariant = {};
    let attributes = {};
    let stockCode = null;
    let returnArtworkMapping = returnArtwork ? 'RA' : 'NR';

    window.kidsArt.response.steps.forEach((step) => {
        const options = {};
        step.options.forEach((option) => {
            options[option.code] = option.id
        })
        attributes[step.code] = options;

        if (step.code === 'page_count') {
            const pageCountOption = step.options.find((option) => option.code == pageCount);
            stockCode = pageCountOption.additionalFields.find((field) => field.code === 'stock_code').optionIds[0];
        }
    });

    matchingVariant = window.kidsArt.response.variants.find((variant) => {
        let matchStockCode = false;
        let matchPageCount = false;
        let matchReturnArtwork = false;
        variant.attributeValues.forEach((value) => {
            if (value.code == 'stock_code' && value.option_id == stockCode) {
                matchStockCode = true;
            }
            if (value.code == 'page_count' && value.option_id == attributes.page_count[pageCount]) {
                matchPageCount = true;
            }
            if (value.code == 'return_artwork' && value.option_id == attributes.return_artwork[returnArtworkMapping]) {
                matchReturnArtwork = true;
            }
        })
        if (matchStockCode && matchPageCount && matchReturnArtwork) {
            return true;
        }
    });

    const steps = {
        cover_design: coverDesign,
        title: title,
        stock_code: stockCode,
        page_count: attributes.page_count[pageCount],
        return_artwork: attributes.return_artwork[returnArtworkMapping]
    };
    return await addConfigurableProductToCart(window.kidsArt.response.productCode, steps, matchingVariant.sku);
};


// WEBPACK FOOTER //
// ./src/ConfigurableProduct/KidsArtwork.js